export default __webpack_public_path__ + "static/media/search.68cc7359.svg";